<form class="mu-position-relative mu-form-content mu-verify-code-form" [formGroup]="formData" autocomplete="nope">
  <div class="mu-custom-grid-container">
    <div class="mu-custom-cell" *ngFor="let input of formInputs; index as i">
      <input
        #formRow
        pInputText
        type="text"
        formControlName="{{ input }}"
        maxlength="1"
        (keyup)="keyUpEvent($event, i)"
        class="mu-input-opt"
        autocomplete="nope"
        [ngClass]="{ 'mu-auth-code-error': inputCodeError }"
      />
      <em *ngIf="inputCodeError" class="fas fa-times-circle mu-error-input mu-auth-icon-error"></em>
    </div>
  </div>

  <em *ngIf="formData?.valid" class="fas fa-check-circle mu-succes-input mu-form-input-phone"></em>
  <div class="p-grid p-dir-col">
    <div class="p-col-12 mu-without-padding">
      <p-button
        type="submit"
        class="mu-button mu-without-padding mu-auth-button"
        [label]="'form.button.verify' | translate"
        [disabled]="formData?.invalid"
        (click)="verifyCode()"
        *ngIf="formData?.valid"
      >
        <app-loading [showLoading]="showLoginLoading" type="icon"></app-loading>
      </p-button>
      <p-button
        type="button"
        class="mu-button mu-without-padding mu-auth-button-resend mu-auth-button"
        [label]="'form.button.resend' | translate"
        [disabled]="!enabledButton"
        (click)="resendVerifyCode()"
        *ngIf="formData?.invalid"
      >
        <app-loading [showLoading]="showLoginLoadingSms" type="icon"></app-loading>
      </p-button>
    </div>
  </div>
</form>
